<ngx-spinner [name]="'relatorio-pagamentos'" type="ball-clip-rotate-pulse" [fullScreen]="false"
    bdColor="rgba(0, 0, 0, 0.2)"></ngx-spinner>
<mat-card>
    <mat-card-header>
        <mat-card-title>Relatório de pagamentos</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content>

        <div class="row">
            <div class="col-auto">
                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>Período</mat-label>
                    <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [max]="maxDate" [min]="minDate"
                        disabled>
                        <input matStartDate formControlName="start" placeholder="Início">
                        <input matEndDate formControlName="end" placeholder="Fim">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>

                    <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Data inicial inválida
                    </mat-error>
                    <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Data final inválida</mat-error>
                </mat-form-field>
            </div>

            <div class="col-2">
                <mat-form-field appearance="fill" [floatLabel]="'always'">
                    <mat-label>Tipo do pagamento</mat-label>
                    <mat-select [(ngModel)]="sBuscaTipoPagamento">
                        <mat-option *ngFor="let tipo of aTiposPagamento" [value]="tipo.value">
                            {{tipo.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-2">
                <mat-form-field appearance="fill" [floatLabel]="'always'">
                    <mat-label>Status do pagamento</mat-label>
                    <mat-select [(ngModel)]="sBuscaStatusPagamento">
                        <mat-option *ngFor="let tipo of aStatusPagamento" [value]="tipo.value">
                            {{tipo.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-2">
                <button class="mt-4" mat-flat-button color="primary" (click)="buscarRelatorioMovimentacaoPeriodo()">
                    <mat-icon>search</mat-icon> Buscar
                </button>
            </div>
        </div>

        <div class="row" *ngIf="pedidos.length > 0;">
            <div class="col-sm-12">
                <hr />
            </div>
            <div class="col-auto">
                <h4>Valor total: {{
                    (valorTotalPedidos | currency:'BRL':'symbol':'1.2-2')
                    .replace('R$', 'R$ ').replace('.', ',').replace(',', '.')
                    }}</h4>
                <h4>Valor total pendentes: {{
                    (valorTotalPagamentosPendentes | currency:'BRL':'symbol':'1.2-2')
                    .replace('R$', 'R$ ').replace('.', ',').replace(',', '.')
                    }}</h4>
            </div>

            <div class="col-auto">
                <button type="button" class="btn btn-success" (click)="exportar()">
                    <div class="config">
                        <img src="./assets/file-excel-solid.svg" style="height: 15px;">
                        <span style="margin-left: 5px; margin-top: 25px;"> .EXCEL</span>
                    </div>
                </button>
            </div>

        </div>
    </mat-card-content>
</mat-card>